import { Fragment, useState, useEffect, createContext } from "react";
import Link from "next/link";
import Menuitem from "./menu";
import { Dialog, Transition } from '@headlessui/react'
import { Bars3Icon, BellIcon, XMarkIcon } from '@heroicons/react/24/outline';
import Mobilemenu from "./mobilemenu";
import Image from 'next/image';
import { useRouter } from "next/router";
import Head from "next/head";
import IMAGES from "@/public/assets/img";
import loadable from '@loadable/component';
import { WEB_URL,ENDPOINTS } from "@/config/endpoints";
import DownloadAppStrip from "./downloadappstrip";
import DeviceChecker from "@/component/shared/deviceChecker";
import ShimmerBar from "./shimmerBar";
import enIN from "@/locales/common/enIN";
import esMX from "@/locales/common/esMX";
import enUS from "@/locales/common/enUS";
import AuthFlow from "@/component/shared/auth/AuthFlow";
import ProfileSidebar from "@/component/shared/auth/ProfileSidebar";
import { pushCleverTapEvent } from "@/component/shared/pushCleverTapEvent";


const ReactWhatsapp = loadable(() => import('react-whatsapp'))


function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

export default function Header() {
  const router = useRouter();
  const { locale } = router;
  const t = (locale === 'es-mx' && esMX) || (locale === 'en-us' && enUS) || (locale === 'en-in' && enIN);
  const [selectedName, setSelectedName] = useState('India');
  const [isMobile, setIsMobile] = useState(false);

  const [open, setOpen] = useState(false);
  const [showTopbar, setShowTobpar] = useState(true);
  const [isiOSDevice, setIsiOSDevice] = useState(false);


  // Authentication state
  const [showAuth, setShowAuth] = useState(false);
  const [authStep, setAuthStep] = useState('login');
  const [user, setUser] = useState(null);
  const [showProfile, setShowProfile] = useState(false);
  const [showSuccessNotification, setShowSuccessNotification] = useState(false);

  const currentPath = router.pathname;

  const routerPath = (router.pathname == "/" ||
    router.pathname == "/export-factoring" ||
    router.pathname == 'export-factoring/invoice-discounting-platform' ||
    router.pathname == '/export-factoring/purchase-order-financing' ||
    router.pathname == '/invoice-discounting-for-smes' ||
    router.pathname == '/enterprise/early-payment-discount' ||
    router.pathname == '/enterprise/vendor-financing-india' ||
    router.pathname == '/enterprise/channel-financing-india' ||
    router.pathname == '/about-us' || router.pathname == '/careers' ||
    router.pathname == '/partner-program' || router.pathname == '/contact-us' ||
    router.pathname == '/enterprise' || router.pathname == '/blogs' || router.pathname == '/blogs/[blogs]' || router.asPath.includes('/case-studies') || router.asPath.includes('/news') || router.asPath.includes('/webinar') || router.asPath.includes('/events') || router.asPath.includes('/videos') ||
    router.pathname == '/hsn-code' || router.pathname == '/hsn-code/[hsnCode]' || router.pathname == '/hsn-code/chapter/[index]'
  )


  const [headerImg, setheaderImg] = useState('/assets/img/Shared/credlix-logo.png')

  const checkMexicoBlogsDetail = router.pathname == '/blogs/[blogs]' || router.pathname == '/news/[news]' || router.pathname == '/blogs/category/[id]/[slug]' && (locale == 'es-mx')
  // console.log('checkMexicoBlogsDetail',router.pathname,checkMexicoBlogsDetail)
  const checkIndiaBlogsDetail = router.pathname == '/blogs/[blogs]' || router.pathname == '/news/[news]' || router.pathname == '/blogs/category/[id]/[slug]' && (locale == '' || locale == 'en-in')


  const handleItemClick = (name, localeName) => {
    setSelectedName(name);
    const eventMap = {
      'es-mx': 'MX_Switch',
      'en-us': 'USA_Switch',
    };
    if (eventMap[localeName]) {
      pushCleverTapEvent(eventMap[localeName], { PageName: 'HomePage' });
    }

    // Clean any existing locale prefix from the current path to prevent nesting
    let cleanPath = router.asPath;
    const supportedLocales = ['es-mx', 'en-in', 'en-us'];
    for (const loc of supportedLocales) {
      if (cleanPath.startsWith(`/${loc}/`)) {
        cleanPath = cleanPath.replace(`/${loc}`, '');
        break;
      } else if (cleanPath === `/${loc}`) {
        cleanPath = '/';
        break;
      }
    }
    // Handle country-specific tools/pages when switching locales
    if (router.pathname.startsWith('/hsn-code')) {
      // HSN codes are only valid for India ('en-in')
      if (localeName !== 'en-in') {
        cleanPath = '/hsn-code';
      }
    }

    if (supportedLocales.includes(localeName)) {
      router.push(cleanPath, undefined, { locale: localeName });
    } else {
      router.push('/');
    }
  };

  // Authentication handlers
  const handleShowLogin = () => {
    setAuthStep('login');
    setShowAuth(true);
    if (typeof window !== "undefined" && typeof window.gtag === "function") {
      window.gtag('event', 'login_click');
    }
    pushCleverTapEvent("login_click", {'PageName': 'Login' });
  };

  const handleShowSignUp = () => {
    setAuthStep('signup');
    setShowAuth(true);
  };

  const handleCloseAuth = () => {
    setShowAuth(false);
  };

  const handleAuthSuccess = (result) => {

    // Only auto-login for login type, not signup
    if (result.type === 'login') {
      // Handle login success - set user and store in localStorage
      setUser(result.data || result.data.formData);
      localStorage.setItem('credlix_user', JSON.stringify(result.data));
      if (typeof window !== "undefined") {
        window.dispatchEvent(new Event('credlix_auth_change'));
      }
      setShowAuth(false);
      
      // Show success notification if this is auto-login after signup
      if (result.isAutoLoginAfterSignup) {
        setShowSuccessNotification(true);
        
        // Hide notification after 3 seconds
        setTimeout(() => {
          setShowSuccessNotification(false);
        }, 3000);
      }
    } else if (result.type === 'signup') {
      // Handle signup success - close modal and show success notification
      setShowAuth(false);
      setShowSuccessNotification(true);

      // Hide notification after 3 seconds
      setTimeout(() => {
        setShowSuccessNotification(false);
      }, 3000);
    }
  };

  const handleLogout = () => {
    setUser(null);
    localStorage.removeItem('credlix_user');
    localStorage.removeItem('credlix_auth_token');
    localStorage.removeItem('credlix_remember_email');
    if (typeof window !== "undefined") {
      window.dispatchEvent(new Event('credlix_auth_change'));
    }
    window.gtag('event', 'logout');
    pushCleverTapEvent("logout",{'PageName': 'Profile_Sidebar'});
  };

  // Check for existing user on component mount
  useEffect(() => {
    const savedUser = localStorage.getItem('credlix_user');
    if (savedUser) {
      try {
        setUser(JSON.parse(savedUser));
      } catch (error) {
        console.error('Error parsing saved user:', error);
        localStorage.removeItem('credlix_user');
      }
    }
  }, []);

  const getClassForURL = () => {
    if (currentPath === '/export-factoring/buyer-credit-check') {
      return 'lg:px-3'
    } else {
      return 'lg:px-3'
    }
  };
  const dynamicClass = getClassForURL();


  const handleImageClick = () => {
    // Open WhatsApp chat when the image is clicked
    const whatsappButton = document.querySelector('.react-whatsapp-button');
    whatsappButton.click();
  };
  const changeRoute = () => {
    const params = window.location.href.split("/");
    const country = params[params.length - 1] || 'en';
    router.push(`https://app.credlix.com/nuphi/#/signup-exporter?country=${country}`);
  }


  useEffect(() => {
    function handleResize() {
      setIsMobile(window.innerWidth < 1024); // Adjust the breakpoint as needed
    }

    // Set initial state
    handleResize();

    // Add event listener to window resize
    window.addEventListener('resize', handleResize);
    if (router.pathname == '/en-us/blogs' || router.asPath == '/en-us/blogs/[blogs]') {
      router.push('/blogs')
    }

    // Remove event listener on component unmount
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (

    <>
      <Head>
        <link rel="preload" as="image" href={IMAGES.HOMEIMG.whatsAppLogo.src} />
        <link rel="preload" as="image" href={IMAGES.SHARED.indiaLogo.src} />
        <link rel="preload" as="image" href={IMAGES.SHARED.mexicoLogo.src} />
        <link rel="preload" as="image" href={IMAGES.SHARED.usaLogo.src} />
      </Head>
      {router.pathname != '/india-mexico-supplier' &&
        <header className={[
          'mx-auto  z-[99] w-full fixed ease-in-out transition duration-500 top-0 bg-white',
          routerPath ? 'home-header normal' : 'bg-[#fff] shadow-normal fixed',
        ].join(' ')}>
          <DeviceChecker>
            {t.ShimmerSec &&
              // <DownloadAppStrip /> 
              <ShimmerBar />
            }
          </DeviceChecker>
          <div className="max-w-[1366px] md:container mx-auto px-3 lg:px-3 md:py-2 xm:py-2 md:px-3 sm:px-3 sm:py-1 py-1 transition ease-in-out duration-1000">
            <div className="flex w-full justify-between md:py-0 bannerLogo">
              <div className="flex items-center ">
                <Link className="block" href='/'><Image src={headerImg} alt="Credlix logo" width="110" height="31" /></Link>
              </div>

              <div className="flex items-center justify-start w-full">
                {router.pathname != '/india-mexico-connect' && router.pathname != '/india-mexico-buyer' &&

                  <Menuitem />
                }

                <div className="ml-auto flex">
                  <ul className="flex items-center">
                    {/* {t.WhatsAppText && */}
                    <DeviceChecker>
                      <li>
                        <div className="relative w-[80px] block sm:hidden height-[60px] text-center z-[99]">
                        <Link href={ENDPOINTS.WHATSAPP_API} target="_blank" rel="noopener noreferrer">
                        <Image 
                          src={IMAGES.HOMEIMG.whatsAppLogo} 
                          width={30} 
                          height={30} 
                          className="mx-auto" 
                          alt="Connect on WhatsApp" 
                          onClick={() => pushCleverTapEvent("Whatsapp", { "PageName": 'HomePage' })}
                        />
                      </Link>
                      </div>
                        <div className="relative w-[80px] sm:block hidden height-[60px] text-center z-[99]">
                        <Link href={ENDPOINTS.WHATSAPP_API} target="_blank" rel="noopener noreferrer">
                        <Image 
                          src={IMAGES.HOMEIMG.whatsAppLogo} 
                          width={30} 
                          height={30} 
                          onClick={() => pushCleverTapEvent("Whatsapp", { "PageName": 'HomePage' })}
                          className="mx-auto" 
                          alt="Connect on WhatsApp" 
                        />
                      </Link>
                        </div>
                      </li>


                    </DeviceChecker>
                    {/* } */}

                    <li className="relative group sm:mr-1 min-w-[80px]">
                      <div className={router.asPath === '/' ? "text-brand flex items-center" : "text-brand flex items-center"}>

                        {locale == 'en-in' &&
                          <div className="flex items-center">
                            <Image src={IMAGES.SHARED.indiaLogo} width={20} height={20} className="mx-auto" alt="Connect on WhatsApp" />
                            <span className="text-sm md:text-xs font-regular ml-[5px]">IND</span>
                          </div>
                        }
                        {locale == 'es-mx' &&
                          <div className="flex items-center">
                            <Image src={IMAGES.SHARED.mexicoLogo} width={20} height={20} className="mx-auto" alt="Connect on WhatsApp" />
                            <span className="text-sm md:text-xs font-regular ml-[5px]">MEX</span>
                          </div>

                        }
                        {locale == 'en-us' &&
                          <div className="flex items-center">
                            <Image src={IMAGES.SHARED.usaLogo} width={20} height={20} className="mx-auto" alt="Connect on WhatsApp" />
                            <span className="text-sm md:text-xs font-regular ml-[5px]">USA</span>
                          </div>

                        }
                        <svg className='relative mt-[-5px]' xmlns="https://www.w3.org/2000/svg" viewBox="0 0 20 20" width="16" height="16"
                          aria-hidden="true"><path fill="none" d="M0 0h24v24H0z" /><path fill="#022B5C" d="M12 13.172l4.95-4.95 1.414 1.414L12 16 5.636 9.636 7.05 8.222z" /></svg>
                      </div>
                      <div className="absolute invisible group-hover:visible left-[-30px] z-10 pt-[19px] w-screen max-w-[150px] px-1 sm:px-0 ">
                        <div className="overflow-hidden shadow-sm ">
                          <div className="relative grid bg-white py-1">
                            <ul>
                              <li
                                className="text-brand font-regular cursor-pointer">
                                <button disabled={checkMexicoBlogsDetail} locale="en-in" onClick={() => handleItemClick('India', 'en-in')} rel="noopener noreferrer" className={`block text-sm rounded-md p-1 m-1 transition duration-150 ease-in-out  ${checkMexicoBlogsDetail ? 'hover:bg-none' : 'hover:bg-[#f3f3f3]'}`}>India</button>
                              </li>
                              <li
                                className="text-brand font-regular cursor-pointer">
                                <button disabled={checkIndiaBlogsDetail} locale="es-mx" onClick={() => handleItemClick('Mexico', 'es-mx')} rel="noopener noreferrer" className={`block text-sm rounded-md p-1 m-1 transition duration-150 ease-in-out ${checkIndiaBlogsDetail ? 'hover:bg-none' : 'hover:bg-[#f3f3f3]'}`}>Mexico</button>
                              </li>
                              {!router.pathname.includes('/blogs') && !router.pathname.includes('/news') && !router.pathname.includes('/india-mexico-connect') && !router.pathname.includes('/india-mexico-buyer') &&
                                <li
                                  className="text-brand font-regular cursor-pointer">
                                  <button locale="en-us" onClick={() => handleItemClick('USA', 'en-us')} rel="noopener noreferrer" className="block text-sm rounded-md p-1 m-1 transition duration-150 ease-in-out  hover:bg-[#f3f3f3]">USA</button>
                                </li>
                              }

                            </ul>
                          </div>
                        </div>
                      </div>
                      <div className="absolute bottom-[-15px] left-0 w-full h-[4px] bg-gradient-to-r from-[#022B5C] to-[#0363C4] transform origin-bottom scale-x-0 transition-transform duration-200 group-hover:scale-x-100 rounded-[5px] shadow-md"></div>
                    </li>
                    {/* Login section for India */}
                  {!isMobile && router.pathname != '/india-mexico-connect' && router.pathname != '/india-mexico-buyer' && locale === 'en-in' &&
                    <>
                      {user ? (
                        <li onClick={() => setShowProfile(true)}
                          className="pl-[13px] text-sm font-regular text-secondary group relative cursor-pointer hover:bg-gray-50 rounded-md transition"
                        >
                          <div className="flex items-center space-x-1">
                            <span className="text-brand text-sm flex gap-xsp items-center">
                              <Image
                                src={IMAGES.login.profileLogin}
                                width={24}
                                height={24}
                                alt="profile icon"
                              />
                              {user?.email ? `${user.email.slice(0, 4)}...` : user?.name}
                            </span>
                            <svg className='relative mt-[-5px]' xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" width="16" height="16"
                              aria-hidden="true"><path fill="none" d="M0 0h24v24H0z" /><path fill="#022B5C" d="M12 13.172l4.95-4.95 1.414 1.414L12 16 5.636 9.636 7.05 8.222z" /></svg>
                          </div>
                        </li>
                      ) : (
                        <li className='pl-2 md:pl-0  text-sm font-regular text-secondary'>
                          <button
                            onClick={() => {
                              handleShowLogin(); if (t?.Login?.eventsname) { pushCleverTapEvent(t.Login.eventsname, { PageName: t.Login.PageName, }); }
                            }}
                            className='bg-gradient-to-r from-[#022B5C] to-[#0363C4] flex gap-1 text-white text-base rounded-md border border-brand py-[4px] px-2 shadow-md transition-all duration-300 hover:from-[#0363C4] hover:to-[#022B5C]'
                          >
                            <Image src={IMAGES.login.profile} width={24} height={24} alt="profile icon" /> {t.Login?.name || 'Login'}
                          </button>
                        </li>
                      )}
                    </>
                  }
                  {/* Login section for Mexico and USA */}
                  {!isMobile && router.pathname != '/india-mexico-connect' && router.pathname != '/india-mexico-buyer' && (locale === 'es-mx' || locale === 'en-us') &&
                    <>
                      <li className='pl-[13px] text-sm font-regular text-secondary group'>
                        <div className="relative">
                          <Link href={t.Login.href} target='_blank' onClick={() => { t.Login.eventsname && pushCleverTapEvent(t.Login.eventsname, { "PageName": t.Login.PageName, }) }} rel="noopener noreferrer" className='bg-white inline-block text-brand md:text-xs text-base px-2 transition-all'>{t.Login.name}</Link>
                          <div className="absolute bottom-[-15px] left-0 w-full h-[4px] bg-gradient-to-r from-[#022B5C] to-[#0363C4] transform origin-bottom scale-x-0 transition-transform duration-200 group-hover:scale-x-100 rounded-[5px] shadow-md"></div>
                        </div>
                      </li>

                      <li className='pl-[15px] text-sm font-regular text-secondary'>
                        <Link target='_blank' href={t.SignUp.href} onClick={() => { t.SignUp.eventsname && pushCleverTapEvent(t.SignUp.eventsname, { "PageName": t.SignUp.PageName, }) }} rel="noopener noreferrer" className='bg-gradient-to-r from-[#022B5C] md:text-xs to-[#0363C4] inline-block text-white text-base rounded-md border border-brand py-[5px] px-2 shadow-md transition-all duration-300 hover:from-[#0363C4] hover:to-[#022B5C]'>{t.SignUp.name}</Link>
                      </li>
                    </>
                  }
                </ul>
                  <div className="flex items-center sm:visible xm:hidden xl:hidden lg:hidden md:hidden">
                    <span className="sr-only">Open main menu</span>
                    {/* <Bars3Icon onClick={() => setOpen(true)} className="block h-[35px] w-[35px]" aria-hidden="true" /> */}
                    <svg onClick={() => setOpen(true)}
                     xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="32" height="32" fill="currentColor"><path d="M3 4H21V6H3V4ZM3 11H21V13H3V11ZM3 18H21V20H3V18Z"></path></svg>
                  </div>


                </div>
              </div>
            </div>
          </div>

          {showProfile && (
            <div className="fixed inset-0 z-[200] bg-black bg-opacity-50 flex justify-end">
              <ProfileSidebar user={user} onLogout={handleLogout} onClose={() => setShowProfile(false)} />
            </div>
          )}


        </header>}

      <HideMobileMenuContext.Provider value={{ open, setOpen }}>
        <Transition.Root show={open} as={Fragment}>
          <Dialog as="div" className="relative z-[100]" onClose={setOpen}>
            <div className="fixed inset-0" />

            <div className="fixed inset-0 overflow-hidden">
              <div className="absolute inset-0 overflow-hidden bg-[rgba(0,0,0,0.7)] z-[12]">
                <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-14">
                  <Transition.Child
                    as={Fragment}
                    enter="transform transition ease-in-out duration-500 sm:duration-500"
                    enterFrom="translate-x-full"
                    enterTo="translate-x-0"
                    leave="transform transition ease-in-out duration-500 sm:duration-500"
                    leaveFrom="translate-x-0"
                    leaveTo="translate-x-full"
                  >
                    <Dialog.Panel className="pointer-events-auto w-screen max-w-md z-[12]">
                      <div className="flex h-full flex-col overflow-y-scroll bg-white pt-2 pb-6 shadow-xl">
                        <button type="button" className="rounded-md left-[16px] w-[40px] top-1 text-gray-400 hover:text-gray-500 focus:outline-none absolute right-2" onClick={() => setOpen(false)}>
                          <span className="sr-only">Close panel</span>
                          <XMarkIcon className="h-6 w-6 text-white" aria-hidden="true" />
                        </button>
                        <div className="relative px-0">
                          {/* Replace with your content */}
                          <Mobilemenu
                            open={open}
                            user={user}
                            onShowLogin={handleShowLogin}
                            onShowSignUp={handleShowSignUp}
                            onLogout={handleLogout}
                            onShowProfile={() => setShowProfile(true)}
                          />
                          {/* /End replace */}
                        </div>
                      </div>
                    </Dialog.Panel>
                  </Transition.Child>
                </div>
              </div>
            </div>
          </Dialog>


        </Transition.Root>
      </HideMobileMenuContext.Provider>

      {/* Authentication Flow Modal */}
      {showAuth && (
        <AuthFlow
          initialStep={authStep}
          onClose={handleCloseAuth}
          onAuthSuccess={handleAuthSuccess}
        />
      )}

      {/* Success Notification - Outside Modal */}
      {showSuccessNotification && (
        <div className="fixed top-24 left-1/2 transform -translate-x-1/2 z-[300] animate-slideDown">
          <div className="text-[#0A7205] rounded-md flex items-center text-sm font-medium border border-[#0A7205] px-4 py-2 bg-[#DFFDDF] shadow-lg">
            <svg className="w-4 h-4 mr-2" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
            </svg>
            Profile created successfully
          </div>
        </div>
      )}
    </>
  )

};

export const HideMobileMenuContext = createContext();